import { render, staticRenderFns } from "./TeremHeader.vue?vue&type=template&id=3f87cebe&scoped=true&"
import script from "./TeremHeader.vue?vue&type=script&lang=js&"
export * from "./TeremHeader.vue?vue&type=script&lang=js&"
import style0 from "./TeremHeader.vue?vue&type=style&index=0&id=3f87cebe&prod&scoped=true&lang=css&"
import style1 from "./TeremHeader.vue?vue&type=style&index=1&id=3f87cebe&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3f87cebe",
  null
  
)

export default component.exports